// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1jm1G","noInteraction":"EventWrapper_noInteraction__1FmbZ","pointerPassthrough":"EventWrapper_pointerPassthrough__26Dwi"};